import { Validation } from './Validation';
import LocationCoordinatesJson from './LocationCoordinatesJson';

export default interface LocationJson {
   ID: number | null,

   /**
    * Name des Orts.
    */
   title: string;

   /**
    * Hinweise und Notizen zu dem Ort.
    */
   remarks: string;

   street: string;
   zip: string;
   city: string;
   country: string;

   /**
    * Koordinaten in Dezimalgrad bzw. Lat, Long
    */
   coordinates: LocationCoordinatesJson | null;
   //TODO: format und validation
}

export function defaultLocationJson() {
   return {
      ID: null,
      title: "",
      remarks: "",
      street: "",
      zip: "",
      city: "",
      country: "",
      coordinates: null,
   };
}

export function validateLocationJsonAddNew(item: LocationJson) {
   return new Validation(item)
      .validateEquals("ID", null)
      .validateNonEmptyString("title", 100)
      .validateString("remarks", 500)
      .validateString("street", 100)
      .validateString("zip", 100)
      .validateString("city", 100)
      .validateString("country", 100)
      .finish();
}

export function validateLocationJson(item: LocationJson) {
   return new Validation(item)
      .validateInteger("ID", 0)
      .validateNonEmptyString("title", 100)
      .validateString("remarks", 500)
      .validateString("street", 100)
      .validateString("zip", 100)
      .validateString("city", 100)
      .validateString("country", 100)
      .finish();
}